import { useEffect, useState } from 'react'
import { Card, Loading, Option, Select, } from '@sede-enterprise/shell-ds-react-framework';
import useGetTempDewPointChartData from '../hooks/useGetTempDewPointChartData';
import { getMinMaxFromGraphData } from '../../../util/helperFunctions';
import Plot from 'react-plotly.js';
import DataTable from '../../../components/DataTable/DataTable';
import useGetDewSeriesSummary from '../hooks/useGetDewSeriesSummary';


const INIT_PAGE = 1;
const INIT_ORDER = "total_hours";
const INIT_ORDER_DIRECTION = 1

const CondensateRiskSummaryList = ({ units,equipmentData, analysisDates }) => {

    const [chart_start_date, setChartStartDate] = useState(null);
    const [chart_end_date, setChartEndDate] = useState(null);
    const [currentPage, setCurrentPage] = useState(INIT_PAGE);
    const [chart_interval, setChartInterval] = useState("MONTH");
    const [cancuiOrder, setCancuiOrder] = useState(INIT_ORDER);
    const [orderDirection, setOrderDirection] = useState(INIT_ORDER_DIRECTION);

    const handleOrderChange = (sortBy, direction) => {
        setCancuiOrder(sortBy);
        setOrderDirection(+direction);
    }

    const handleCurrentPageChange = (current) => {
        setCurrentPage(current);
    }

    const handleRowClick = (row) => {
        setChartStartDate(row.start);
        setChartEndDate(row.end);
    }

    console.log("analysisDates", analysisDates);
    const { data: tempDewPointSummary, loading: tempDewPointSummaryLoading } = useGetDewSeriesSummary(equipmentData, analysisDates, chart_interval);
    useEffect(() => {
        handleRowClick({...tempDewPointSummary[0]});
    }, [tempDewPointSummary]);

    const { data: tempDewPointChartData, loading: tempDewPointChartLoading } = useGetTempDewPointChartData(equipmentData.id, chart_start_date, chart_end_date, units, equipmentData?.site?.id);
    const { min: minDewPointValue, max: maxDewPointValue } = getMinMaxFromGraphData(tempDewPointChartData);
    console.log("tempDewPointChartData", tempDewPointChartData);
    const parentLoading = !(equipmentData?.id && analysisDates?.start);
    return (
        <>

            <div className='cancui-card-container'>
                <div className='cancui-left-card'>
                    <Card className='details-card temp-card' bodyPadding={false}>
                        {(parentLoading || tempDewPointChartLoading) && <div className='loading-container'><Loading /></div>}
                        {!(parentLoading || tempDewPointChartLoading) && tempDewPointChartData?.length > 0 && <Plot
                            useResizeHandler={true}
                            data={tempDewPointChartData}
                            className='model-chart'
                            layout={{
                                autosize: true,
                                height: "100%",
                                margin: {
                                    l: 40,
                                    r: 40,
                                    b: 20,
                                    t: 20,
                                    pad: 5
                                },
                                xaxis: {
                                    automargin: true,
                                    type: "date",
                                },
                                yaxis: {
                                    fixedrange: false,
                                    side: "left",
                                    range: [minDewPointValue - 1, maxDewPointValue + 1],
                                },
                                legend: {
                                    orientation: "h",
                                },
                                hoverdistance: 1,
                                hovermode: "x unified",

                            }} />}
                    </Card>
                </div>

                <div className='cancui-right-card'>
                    <Card className='cancui-details-card' bodyPadding={false}>
                        <div className='cancui-dew-details-card-content'>
                            <div className='details-card-content-col'>
                                <div className='info-container'>
                                    <div className='info-data'>
                                        <div className='select-table-wrapper'>
                                            <div className='dew-summary-container'>
                                                <p className='dew-summary-text data-label'>Summary</p>
                                                <Select className='dew-summary-options' value={chart_interval} showSearch={false} allowClear={false} onChange={(value) => setChartInterval(value)}>
                                                    {['DAY', 'MONTH'].map((header, index) => {
                                                        return <Option key={index} value={header}>{header}</Option>
                                                    })}
                                                </Select>
                                            </div>
                                            <div className='info-container'>
                                                {(parentLoading || tempDewPointSummaryLoading) && <div className='loading-container'><Loading /></div>}
                                                {!(parentLoading || tempDewPointSummaryLoading) && tempDewPointSummary.length > 0 && <DataTable
                                                    count={tempDewPointSummary.length}
                                                    columns={[
                                                        {
                                                            header: 'Start Date',
                                                            accessorFn: (row) => row?.start,
                                                            id: 'start',
                                                        },
                                                        {
                                                            header: 'End Date',
                                                            accessorFn: (row) => row?.end,
                                                            id: 'end',
                                                        },
                                                        {
                                                            header: 'Total Hours',
                                                            accessorFn: (row) => row?.total_hours,
                                                            id: 'total_hours',
                                                        }
                                                    ]}
                                                    data={tempDewPointSummary}
                                                    currentPage={currentPage}
                                                    handleCurrentPageChange={handleCurrentPageChange}
                                                    handleOrderChange={handleOrderChange}
                                                    handleRowClick={(row) => {
                                                        handleRowClick(row)
                                                    }}
                                                    INIT_ORDER={INIT_ORDER}
                                                    INIT_ORDER_DIRECTION={INIT_ORDER_DIRECTION}
                                                    loading={tempDewPointSummaryLoading}
                                                    paginationMode="client"
                                                />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default CondensateRiskSummaryList;